import { Spinner } from "react-bootstrap";

const MySpinner = ()=> {
    return <Spinner animation="grow" variant="primary" />;
}

export default MySpinner;